"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".outter_box[_ngcontent-%COMP%] {\n  max-height: 500px; }\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92YXIvbGliL2plbmtpbnMvd29ya3NwYWNlL01hcHNlbmRlciA0RCBSZWxlYXNlL3dlYnNpdGUvc3JjL2FwcC9tYWluL21hcC9kZXRhaWwtdmlld3MvYW5ub3RzLzNyZF9wYXJ0eS9wcC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJLGtCQUFnQixFQUVuQiIsImZpbGUiOiJzcmMvYXBwL21haW4vbWFwL2RldGFpbC12aWV3cy9hbm5vdHMvM3JkX3BhcnR5L3BwLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLm91dHRlcl9ib3h7XG4gICAgbWF4LWhlaWdodDo1MDBweDtcbiAgXG59XG4iXX0= */"];
exports.styles = styles;
